import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';

import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 



const styles = StyleSheet.create({
          
      
          to: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'left',
          },

          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', // First column with smaller width
          },
          detailsCell: {
            width: '55%', // Second column with larger width
          },
          pageNoCell: {
            width: '40%', // Third column with medium width
          },


          signature: {
            textAlign: 'right',     // to align text to the right
            marginTop: 30,          // optional: add some space on top
          },
          


        });


        
        
const PensionFormA = ({ result }) => {

  
  const tableData = [
    ['1', 'Name (in block letters)', result.employeeName],
    ['2', 'Father’s Name (also husband’s name in the case of female Government Servant)', result.fatherName],
    ['3', 'Designation at the time of retirement', result.designation],
    ['4', 'Name of Office / Department in which employed', result.institutionName],
    ['5', 'Date of Birth (by Christian era)', result.dateOfBirth],
    ['6', 'Date of retirement', result.dateOfRetirement],
    ['7', 'Class of pension on which retired', result.typeOfRetirement],
    ['8', 'Amount of pension authorised', 'Not previously authorised'],
    ['9', 'Fraction of Pension Proposed to be commuted', `40% of Pension i.e. Rs. ${result.commutedPension}/-`],
    ['10', 'Designation of the Audit Officer who authorised pension & Pension Payment Order No./Date', 'Not previously authorised'],
    [
      '11',
      `Desbursing authority for payment of pension.
  a) Treasury/Sub-Treasury (Name and complete address of the Treasury/ Sub-Treasury to be indicated.)
  b) (i) Branch of Nationalised Bank with complete postal address.
  (ii) Bank Account number to which monthly pension is being credited each month.`,
      `${result.treasury}
      ${result.bankName}
      ${result.branchName}
      IFSC: ${result.ifscCode}
      Account No: ${result.accountNumber}`
    ],
  ];

  
  return (
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack]}>FORM - A</Text>
                <Text style={[style.subtitle, { fontSize: 8 }]}>[ See rules 5(2), 6(1), 12, 13, (1) and (2), 14(1) and (2), 15(1) and (2) and 16(1) and (2)]</Text>
                <Text style={[style.subtitle, { fontSize: 12 }]}>
                Form of application for commutation of a fraction of pension without medical examination.
                </Text>

                <View style={style.solidLine} />
                <Text style={[style.subtitle, { fontSize: 8 }]}>(To be submitted in duplicate after retirement but within one year of the date to retirement.)</Text>

                <Text style={[style.title, style.ArialBold]}>PART - I</Text>


                <View style={styles.to}>
                  <Text>To,</Text>
                  <Text >The Administrative Officer,</Text>
                  <Text >Higher Education Grant,</Text>
                  <Text >{result.region} Region, {result.city}.</Text>
                </View>

     
               
                <Text style={[styles.paragraph, { marginLeft: 30 }]}>
                  <Text >Subject:</Text> Commutation of Pension without medical examination.
                </Text>


                <Text >Respected Sir,</Text>
              <View style={{marginLeft:10}}>
                <Text style={styles.paragraph}>I desire to commute a fraction of my pension as indicated below in accordance with provision contained in Maharashtra Civil Services (Commutation of Pensions) Rules 1981. The necessary particulars are furnished below.</Text>

               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>

              </View>


              <Text style={{ marginTop: 30 }}>Place: {result.placeOfRetirement}</Text>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
                <Text>Date: </Text>
                <AutoText style={[style.signature] }>{result.employeeName}</AutoText>
              </View>

   

              </View>

);
};

export default PensionFormA;